import rootConfig from '../config';

export const config = {
  apiUrl: `${rootConfig.root}${rootConfig.api}`,
  email: rootConfig.SITE_EMAIL,
  survey: rootConfig.SITE_SURVEY_LINK,
  phoneNumber: rootConfig.SITE_PHONE
};
